import { render, staticRenderFns } from "./EditorialEssaysPanel.vue?vue&type=template&id=67f5140e&scoped=true"
import script from "./EditorialEssaysPanel.vue?vue&type=script&lang=js"
export * from "./EditorialEssaysPanel.vue?vue&type=script&lang=js"
import style0 from "./EditorialEssaysPanel.vue?vue&type=style&index=0&id=67f5140e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f5140e",
  null
  
)

export default component.exports